import { render, staticRenderFns } from "./prescriptionOne.vue?vue&type=template&id=e25a2dda&scoped=true"
import script from "./prescriptionOne.vue?vue&type=script&lang=ts"
export * from "./prescriptionOne.vue?vue&type=script&lang=ts"
import style0 from "./prescriptionOne.vue?vue&type=style&index=0&id=e25a2dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25a2dda",
  null
  
)

export default component.exports